"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mandatoryDocumentationSchema = void 0;
exports.mandatoryDocumentationSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        completeClaimReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD',
        },
        completeMainClaimReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD',
        },
        informationSentToNationalRecoveriesCentreDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        judgmentBankruptcyInformationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        mortgageAssignmentDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        titleTransferDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
    },
};
